import EditIcon from "./icons/pencilWhite.png";
import AddIcon from './icons/Add.png';
import LogoutIcon from './icons/logoutWhite.png';
import HelpIcon from './icons/help.png';
import SearchIcon from './icons/searchWhite.png';
import ProfileIcon from './icons/profileWhite.png';
import HomeIcon from './icons/homeWhite.png';
import RegisterIcon from './icons/taskIcon.png';
import TicketPictureIcon from './icons/bugWhite.png';
import FeatureIcon from './icons/featureYaleBlue.png';
import EnhancementIcon from './icons/cog.png';
import arrowRedIcon from "./icons/arrowRed.png";
import TaskIcon from './icons/taskIcon.png';
import RedesignIcon from './icons/designWHITE.png';
import MenuIcon from "./icons/dotMenu.png";
import RepoIcon from './icons/code.png';
import GlobeIcon from './icons/globe.png';
import DetailsIcon from './icons/panel.png';
import AddTicketIcon from './icons/plus.png';
import CommentsIcon from './icons/comments.png';
import SprintsIcon from './icons/sprint.png';
import SprintsWhiteIcon from './icons/sprintWhite.png';
import RoundMenu from './icons/dot-menu-white.png';
import ArchivesIcon from './icons/archive.png';
import ActivitiesIcon from './icons/wave.png';
import TrashCanIcon from './icons/trashCan196ecf.png';
import LinkIcon from './icons/linkWhite.png';

import ListIcon from './icons/blackList.png';
import ColumnIcon from './icons/blackColumns.png';

import CircleCheckboxIcon from './icons/circleCheckFilled196ecf.png';
import TriangleWarningIcon from './icons/triangleWarningFilled196ecf.png';
import ChatboxWarningIcon from './icons/chatboxWarningFilled196ecf.png';
import ClockIcon from './icons/clock.png';

// warning icons
export const CircleCheckbox = CircleCheckboxIcon;
export const TriangleWarning = TriangleWarningIcon;
export const ChatboxWarning = ChatboxWarningIcon;

// nav icons
export const Logout = LogoutIcon;
export const Help = HelpIcon;
export const Search = SearchIcon;
export const Profile = ProfileIcon;
export const Home = HomeIcon;
export const Register = RegisterIcon;

// project nav icons
export const Repo = RepoIcon;
export const Globe = GlobeIcon;
export const Details = DetailsIcon;
export const AddTicket = AddTicketIcon;
export const Comments = CommentsIcon;
export const Sprints = SprintsIcon;
export const ArchiveIcon = ArchivesIcon;
export const ActivityIcon = ActivitiesIcon;

// ticket icons
export const TicketPicture = TicketPictureIcon;
export const Feature = FeatureIcon;
export const Enhancement = EnhancementIcon;
export const ArrowRed = arrowRedIcon;
export const Task = TaskIcon;
export const Redesign = RedesignIcon;
export const Menu = MenuIcon;
export const Trash = TrashCanIcon;
export const Link = LinkIcon;
export const SprintWhite = SprintsWhiteIcon;
export const ClockWhite = ClockIcon;

// general icons
export const Edit= EditIcon;
export const Add = AddIcon;
export const RoundDotMenu = RoundMenu;
export const List = ListIcon;
export const Columns = ColumnIcon;